import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import type { BatchIgnoreService } from '../batch-ignore-service';
import { BatchIgnoreApi } from '../../apis/batch-ignore-api';

@injectable()
export class BatchIgnoreServiceImpl implements BatchIgnoreService {
    constructor(
        @inject(BatchIgnoreApi)
        private _batchIgnoreApi: BatchIgnoreApi,
    ) {}

    async batchIgnoreIssues(issueIds: string[]): Promise<void> {
        if (!issueIds || issueIds.length === 0) {
            throw new Error('Issue IDs array cannot be empty');
        }

        await this._batchIgnoreApi.batchIgnore({
            check_result_id: issueIds,
        });
    }
}
